import { Injectable } from '@angular/core';
import { ColorScheme } from './color.interface';
import { COLOR_SCHEME_EXCEL } from './schemes/color.scheme.excel';
import { COLOR_SCHEME_CLUSTERS } from './schemes/color.scheme.clusters';

/**
 * Color scheme utility.
 *
 * Handles color schemes.
 *
 * For use in menu's, editors, etc.
 *
 * @todo Bbn color scheme (menu's, etc.)
 * @todo Variable color schemes, i.e. for different tenants.
 */
@Injectable({
  providedIn: 'root'
})
export class ColorService {

  constructor() { }

  /**
   * Get color scheme.
   *
   * @param scheme The requested scheme.
   * @returns The color scheme. When scheme is not found, return empty scheme to
   *  prevent code errors.
   */
  public getScheme(scheme: 'clusters' | 'excel'): ColorScheme {
    switch (scheme) {
      case 'clusters':
        return this._setLabels(COLOR_SCHEME_CLUSTERS);
      case 'excel':
        return this._setLabels(COLOR_SCHEME_EXCEL);
      default:
        console.warn(`Color scheme '${ scheme }' does not exist.`);
        return [];
    }
  }

  /**
   * Set/translate labels.
   *
   * @todo Get current user language. Now hardcoded to 'nl'.
   *
   * @scheme The color scheme to add the labels for.
   * @returns The color scheme with added labels.
   */
  private _setLabels(scheme: ColorScheme): ColorScheme {
    for (const color of scheme) {
      color.displayName = color.languages.find(l => l.language === 'nl').displayName;
    }
    return scheme;
  }
}
